import React from 'react';
import {Doughnut as DoughnutRC} from "react-chartjs-2";

const Doughnut = (props) => {
    return (
        <DoughnutRC {...props}/>
    );
};
export default Doughnut;
